import React from "react";
import { BookOpenIcon, CheckIcon, GiftIcon, TrophyIcon } from "lucide-react";
import { images } from "../../data/content";
import { OfferBlock } from "../OfferBlock";
const perks = ["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees", "7-day guarantee"];
export function OfferStack() {
  return <section id="offer" className="bg-navy-deep px-5 py-16 md:py-24" data-id="element-211" data-mp="13r68lr87nwq">
      <div className="mx-auto max-w-2xl" data-id="element-212" data-mp="ou4pbmru2cf6">
        <div className="text-center" data-id="element-213" data-mp="ov68yfmx078i">
          <p className="flex items-center justify-center gap-2 text-xs font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-214" data-mp="tsps9tygza7b">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-215" data-mp="f2ih7zasktgn" />
            Special launch offer
          </p>
          <h2 className="mt-3 font-serif text-[30px] font-black leading-[1.1] text-white md:text-5xl" data-id="element-216" data-mp="k0s9a117zdy1">
            Here's everything you'll receive <em className="italic text-gold" data-id="element-217" data-mp="1cinwu0326l67">today</em>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white" data-id="element-218" data-mp="1ckiijgm5mhbc">
          <img src={images.mockup} alt="Complete Abdominoplasty Master System bundle" className="block w-full bg-cream" data-id="element-219" data-mp="18xef2njar605" />

          <div className="p-5 md:p-8" data-id="element-220" data-mp="13vp395o92ob0">
            <ul className="divide-y divide-navy/10" data-id="element-221" data-mp="1in7rfqr9jp5g">
              <li className="flex items-center gap-3 py-4" data-id="element-222" data-mp="1iosl7e5r7429">
                <BookOpenIcon className="h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-223" data-mp="1duy3uhdmf16c" />
                <div className="min-w-0 flex-1" data-id="element-224" data-mp="1rmkykcrx01n0">
                  <p className="font-bold text-navy" data-id="element-225" data-mp="1rpgwi13riqbg">The Abdominoplasty Master System™</p>
                  <p className="text-sm text-navy/60" data-id="element-226" data-mp="1mqdtem7ceu64">6 Premium Volumes</p>
                </div>
                <s className="shrink-0 font-bold text-navy/50" data-id="element-227" data-mp="21ksecsagwdnf">$97</s>
              </li>
              <li className="flex items-center gap-3 py-4" data-id="element-228" data-mp="1wn0cb5g3zb5i">
                <GiftIcon className="h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-229" data-mp="7710thp0p9mp" />
                <div className="min-w-0 flex-1" data-id="element-230" data-mp="28zfeq44cy82">
                  <p className="font-bold text-navy" data-id="element-231" data-mp="2aaienpqq1y4">5 Professional Bonuses</p>
                  <p className="text-sm text-navy/60" data-id="element-232" data-mp="rxwrb0noigd6">Cases, cards, atlas & 30-day challenge</p>
                </div>
                <s className="shrink-0 font-bold text-navy/50" data-id="element-233" data-mp="vyoy7n92w96a">$197</s>
              </li>
            </ul>

            <div className="mt-2 rounded-2xl bg-cream p-5 text-center" data-id="element-234" data-mp="10vyo140dqmun">
              <p className="text-sm font-bold uppercase tracking-widest text-navy/60" data-id="element-235" data-mp="15x5vf1ym1k0s">
                Total value: <s className="text-alert" data-id="element-236" data-mp="1auo6axw6u9bf">$294</s>
              </p>
              <p className="mt-3 text-[15px] text-navy/75" data-id="element-237" data-mp="1ewj6u06aoio5">But today, you get complete access for:</p>
              <p className="mt-1 font-serif text-7xl font-black leading-none text-cta md:text-8xl" data-id="element-238" data-mp="1jn9cleimunjd">$27</p>
              <p className="mt-2 text-sm font-black uppercase tracking-[0.2em] text-navy" data-id="element-239" data-mp="1on42beqo972u">One-time payment</p>
            </div>

            <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-240" data-mp="1tn8nhi2iypze">
              {perks.map(p => <li key={p} className="flex items-center gap-2 text-[15px] font-semibold text-navy" data-id="element-241" data-mp="1yltnbgdv77nb">
                  <CheckIcon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-242" data-mp="3j4nnmnh6ri1z" />
                  {p}
                </li>)}
            </ul>

            <p className="mt-5 text-center text-[15px] leading-relaxed text-navy/70" data-id="element-243" data-mp="394daf2v5iamt">
              For less than the cost of many professional educational resources, you'll have a structured case-review
              system you can return to whenever you want to practice.
            </p>

            <div className="mt-6" data-id="element-244" data-mp="pd4y16taatp">
              <OfferBlock label="Get the Abdominoplasty Master System™ for $27" sub="Secure checkout · Instant digital access · 7-day guarantee" data-id="element-245" data-mp="qeeu2c3cr9u" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}